import React from 'react';
import {UncontrolledAlert} from 'reactstrap';
const Error = ({error}) => {
    if (!error) {
        return null;
    }
    return (
        <UncontrolledAlert color="danger">
            {error.message}{error.response && error.response.data && error.response.data.message &&
                error.response.data.message.length !== 0 && `: ${error.response.data.message}`}
        </UncontrolledAlert>
    );
};

export default Error;
